import { Component, OnDestroy, OnInit } from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { NuevoClienteDTO } from "app/main/apps/shared/models/cliente.model";

import { Subscription } from "rxjs";
import { finalize, retry } from "rxjs/operators";
import { DialogClienteComponent } from "./components/dialog-cliente/dialog-cliente.component";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
import { ClienteDTO } from "app/main/apps/shared/interfaces/cliente.interface";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { ClienteService } from "app/main/apps/shared/services/rest/cliente.service";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { Filtro } from "app/main/apps/shared/interfaces/filtro.interface";
import { FiltroCliente } from "app/main/apps/shared/interfaces/filtro-cliente";
import { FiltrosService } from "app/main/apps/shared/services/util/filtros.service";

@Component({
    selector: "app-clientes",
    templateUrl: "./clientes.component.html",
    styleUrls: ["./clientes.component.scss"],
    animations: fuseAnimations,
})
export class ClientesComponent implements OnInit, OnDestroy {
    total:number;
    esSupervisor: boolean;
    clientes: ClienteDTO[];
    estados: Filtro[];
    totalRegistros:number;
    mostrarFiltros: boolean;
    private subscripciones: Subscription;
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _dialogSrvc: DialogService,
        private _clienteSrvc: ClienteService,
        private _menuUsuarioSrvc: MenuUsuarioService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _notificacionSrvc: NotificacionesService,
        private _filtroSrvc: FiltrosService,
    ) {
        this.mostrarFiltros = false;
        this._filtroSrvc.getFiltro("filtrosClientes");
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
    }

    ngOnInit(): void {

        this.estados = [
            {
                valor: 1,
                descripcion: "Activos",
                tipo: null,
            },
            {
                valor: 2,
                descripcion: "Inactivo",
                tipo: null,
            },
        ];

        this.esSupervisor = this._menuUsuarioSrvc.esSupervisor();
        this.buscarClientes();

        //if (this._menuUsuarioSrvc.esSupervisor()) {
        //    this._clienteSrvc
        //        .fetchClientes(0, "desc")
        //        .subscribe((resp) => (this.clientes = resp.content));
        //} else {
        //    this.clientes = [];
        //}

    }

 /*   buscarCliente(paginacion: any) {
        console.log(paginacion);
        const { sort, page, resultados } = paginacion;
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._clienteSrvc
                .fetchClientes(page, sort)
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe(
                    (clientes) => {
                        this.totalRegistros = clientes.totalElements;
                        this.clientes = clientes.content;
                        this._clienteSrvc.clientesChanged$.next(clientes);
                    } //(this.clientes = clientes.content)
                )
        );
    }
*/

buscarClientes() {
    this._fuseProgressBarService.show();
    this.subscripciones.add(
        this._clienteSrvc
            .fetchClientes()
            .pipe(finalize(() => this._fuseProgressBarService.hide()))
            .subscribe((resp) => {

                //console.log(resp);

                this.clientes = resp.content;
                this._clienteSrvc.clientesChanged$.next(resp);
                this._clienteSrvc.setCantidadPaginas(resp.totalPages);
                this.total = resp.totalElements;
                //this._facturaSrvc.setTotalDeResultados(
                //    resp.totalElements
                //);
                this._clienteSrvc.setPaginaActual(
                    resp.pageable.pageNumber
                );
                this._clienteSrvc.setCantidaResultadosPorPagina(
                    resp.size
                );
            })
    );
}

    nuevoCliente() {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogClienteComponent,
            "clase-dialog",
            "500px",
            { editar: false }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                //console.log(result);
                //console.log("llego a grabar");
                let nuevo = new NuevoClienteDTO(
                    result.rut.split("-")[0],
                    result.rut.split("-")[1],
                    result.razonSocial
                );
                let c = this._clienteSrvc.save(nuevo).subscribe((resp) => {
                    this._notificacionSrvc.mostrarNotificacion(
                        "El cliente ha sido registrado exitosamente",
                        "success"
                    )
                    this.clientes = null;
                    this.buscarClientes();
                });
                //console.log(c);
            }
        });
    }

    filtrar(event: FiltroCliente) {
        this._clienteSrvc.resetPaginador();
        this._clienteSrvc.clienteRefresh$.next(true);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
